import React from 'react';

// Flowing Lines Component (simplified for better loading)
export function FlowingLines({ theme = 'emerald', opacity = '30' }) {
  // Remove complex animation restart logic that causes loading issues

  const getThemeColors = (theme) => {
    // Use inline styles for better opacity control
    const baseOpacity = Math.min(80, parseInt(opacity) * 2); // Double the opacity
    const midOpacity = Math.max(40, baseOpacity - 10);
    
    switch (theme) {
      case 'emerald':
        return [
          { color: '#34d399', opacity: baseOpacity / 100 }, // emerald-400
          { color: '#14b8a6', opacity: midOpacity / 100 },  // teal-500
          { color: '#a3e635', opacity: baseOpacity / 100 }, // lime-400
          { color: '#22c55e', opacity: midOpacity / 100 }   // green-500
        ];
      case 'blue':
        return [
          { color: '#60a5fa', opacity: baseOpacity / 100 }, // blue-400
          { color: '#a855f7', opacity: midOpacity / 100 },  // purple-500
          { color: '#818cf8', opacity: baseOpacity / 100 }, // indigo-400
          { color: '#06b6d4', opacity: midOpacity / 100 }   // cyan-500
        ];
      default:
        return [
          { color: '#34d399', opacity: baseOpacity / 100 }, // emerald-400
          { color: '#14b8a6', opacity: midOpacity / 100 },  // teal-500
          { color: '#a3e635', opacity: baseOpacity / 100 }, // lime-400
          { color: '#22c55e', opacity: midOpacity / 100 }   // green-500
        ];
    }
  };

  const colors = getThemeColors(theme);
  const rotations = theme === 'emerald' 
    ? ['15deg', '-12deg', '18deg', '-8deg']
    : ['12deg', '-8deg', '16deg', '-10deg'];
  const widths = theme === 'emerald' 
    ? ['w-96', 'w-80', 'w-72', 'w-full']
    : ['w-96', 'w-80', 'w-full', 'w-72'];
  const positions = theme === 'emerald' 
    ? ['top-1/4', 'top-1/2', 'bottom-1/4', 'bottom-1/2']
    : ['top-1/4', 'top-1/2', 'bottom-1/4', 'bottom-1/2'];

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden">
      {colors.map((color, index) => (
        <div 
          key={`line-${theme}-${index}`}
          className={`flowing-line absolute ${positions[index]} left-1/2 ${widths[index]} h-1 bg-linear-to-r from-transparent to-transparent origin-left`}
          style={{ 
            '--rotation': rotations[index],
            background: `linear-gradient(to right, transparent, ${color.color}, transparent)`,
            opacity: color.opacity
          }}
        />
      ))}
    </div>
  );
}
